import { clubbiStyled } from 'clubbi-ui'

export const CartCardContainer = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.brandWhite.main,
  width: '100%',
}))

export const MissionsDiscountPrice = clubbiStyled('div')(({ theme }) => ({
  color: theme.palette.brandSuccess[70],
}))

export const CartDetailSpan = clubbiStyled('span')(({ theme }) => ({
  fontSize: '12px',
  lineHeight: '109.9%',
  color: theme.palette.brandBlack.main,
  [theme.breakpoints.up('md')]: {
    fontSize: '14px',
  },
}))

export const CartSubtotalInfo = clubbiStyled('span')(({ theme }) => ({
  fontSize: '10px',
  lineHeight: '109.9%',
  color: theme.palette.brandGrey[60],
  margin: '-5px 0 10px 0',
  [theme.breakpoints.up('md')]: {
    fontSize: '12px',
    margin: '0 0 15px 0',
  },
}))

export const CartTotalSpan = clubbiStyled('span')<{ hasProfitabilities?: boolean }>(
  ({ theme, hasProfitabilities = false }) => ({
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '109.9%',
    marginBottom: hasProfitabilities ? '0px' : '16px',
    [theme.breakpoints.up('md')]: {
      fontSize: '20px',
    },
  })
)

export const CartDeliveryWarningSpan = clubbiStyled('span')(({ theme }) => ({
  fontSize: '10px',
  lineHeight: '109.9%',
  color: theme.palette.brandGrey[60],
  [theme.breakpoints.up('md')]: {
    fontSize: '12px',
  },
}))

export const CartDeliveryContainer = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  [theme.breakpoints.up('md')]: {
    gap: '2px',
  },
}))

export const CartTitle = clubbiStyled('div')(({ theme }) => ({
  fontWeight: 500,
  fontSize: '12px',
  marginBottom: '5px',
  [theme.breakpoints.up('md')]: {
    fontSize: '14px',
  },
  color: theme.palette.brandBlack.main,
}))

export const CartDetailDiv = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  height: '30px',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

export const CartDetaiTwoDays = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '5px',
}))

export const CartDetailsSpan = clubbiStyled('span')(({ theme }) => ({
  fontSize: '10px',
  lineHeight: '109.9%',
  color: theme.palette.brandGrey[60],
  marginTop: '-10px',
  [theme.breakpoints.up('md')]: {
    fontSize: '12px',
  },
}))

export const StyledHR = clubbiStyled('hr')(({ theme }) => ({
  width: '100%',
  color: theme.palette.brandGrey[20],
}))

export const StyledDeliveryFree = clubbiStyled('div')(({ theme }) => ({
  color: theme.palette.brandSuccess[70],
  fontWeight: 600,
}))

export const CartProfitabilities = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  marginTop: '-2px',
}))

export const CartProfitabilitiesSpan = clubbiStyled('span')<{
  isNegative?: boolean
}>(({ theme, isNegative = false }) => ({
  fontSize: theme.typography.fontSize2XS,
  lineHeight: '150%',
  color: isNegative ? theme.palette.brandWarning[60] : theme.palette.brandGrey[60],
  [theme.breakpoints.up('md')]: {
    marginTop: 0,
    fontSize: '13px',
  },
}))

export const CartInstallmentsContainer = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',

  [theme.breakpoints.up('md')]: {
    gap: '12px',
  },
}))

export const CartInstallmentsDiv = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  justifyContent: 'space-between',
}))
